import { useSelector } from "react-redux";

import { UserProfile } from "pwapi";

import { FeatureFlags } from "../reducers/sysReducer";

export const useCanSeeFrontEndAdmin = (
  additionalUserTypes?: string[]
): boolean => {
  const features: FeatureFlags = useSelector(({ sys }) => sys.features);
  const currentUser = useSelector(({ auth }) => auth.user);

  const allowedUserTypes = [
    UserProfile.user_type.LAB_ADMIN,
    UserProfile.user_type.ADMIN,
    ...(additionalUserTypes || []),
  ];

  return (
    features?.frontendAdmin ||
    currentUser?.is_superuser ||
    allowedUserTypes.includes(currentUser?.user_type || "")
  );
};

export const useCanSeeLIS = (): boolean => {
  const features: FeatureFlags = useSelector(({ sys }) => sys.features);
  const currentUser = useSelector(({ auth }) => auth.user);

  const allowedUserTypes = [
    UserProfile.user_type.LAB_ADMIN,
    UserProfile.user_type.ADMIN,
  ];

  return (
    features?.canSeeLISLink ||
    currentUser?.is_superuser ||
    allowedUserTypes.includes(currentUser?.user_type || "")
  );
};

export const useCanFlagSlides = (): boolean => {
  const features: FeatureFlags = useSelector(({ sys }) => sys.features);
  const currentUser = useSelector(({ auth }) => auth.user);

  const allowedUserTypes = [
    UserProfile.user_type.LAB_ADMIN,
    UserProfile.user_type.ADMIN,
    UserProfile.user_type.DERMPATH,
  ];

  return (
    features?.canFlagSlides ||
    currentUser?.is_superuser ||
    allowedUserTypes.includes(currentUser?.user_type || "")
  );
};

export const useCanSeeLabStatus = (): boolean => {
  const features: FeatureFlags = useSelector(({ sys }) => sys.features);
  const currentUser = useSelector(({ auth }) => auth.user);

  const disallowedUserTypes = [
    UserProfile.user_type.PHYSICIAN,
    UserProfile.user_type.CLINIC_ADMIN,
  ];

  return (
    features?.labWorkStatus ||
    currentUser?.is_superuser ||
    !disallowedUserTypes.includes(currentUser?.user_type || "")
  );
};

export const canViewInternalDocuments = () => {
  const currentUser = useSelector(({ auth }) => auth.user);

  const allowedUserTypes = [
    UserProfile.user_type.DERMPATH,
    UserProfile.user_type.LAB_ADMIN,
    UserProfile.user_type.ADMIN,
  ];

  return (
    currentUser?.userprofile &&
    allowedUserTypes.includes(currentUser.userprofile.user_type)
  );
};

export const useCanAccessStainOrdering = (): boolean => {
  const features: FeatureFlags = useSelector(({ sys }) => sys.features);
  const currentUser = useSelector(({ auth }) => auth.user);
  const allowedUserTypes = [
    UserProfile.user_type.ADMIN,
    UserProfile.user_type.LAB_ADMIN,
    UserProfile.user_type.DERMPATH,
  ];
  return (
    features?.stainOrdering ||
    currentUser?.is_superuser ||
    allowedUserTypes.includes(currentUser?.user_type || "")
  );
};
